export default {
  meta: {
    title: '上下架审核'
  }
};
